var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTabFeedFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.025 1H15.5123C14.4214 1 13.5371 1.88265 13.5371 2.97147V11.7499C13.5371 12.8387 14.4214 13.7213 15.5123 13.7213H21.025C22.1158 13.7213 23.0001 12.8387 23.0001 11.7499V2.97147C23.0001 1.88265 22.1158 1 21.025 1Z",
    fill: "#FF3239",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6637 17.1445H14.8735C14.1354 17.1445 13.5371 17.7418 13.5371 18.4785V21.6662C13.5371 22.4029 14.1354 23.0001 14.8735 23.0001H21.6637C22.4018 23.0001 23.0001 22.4029 23.0001 21.6662V18.4785C23.0001 17.7418 22.4018 17.1445 21.6637 17.1445Z",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60578 11.799H2.85723C1.83151 11.799 1 12.6289 1 13.6527V21.1462C1 22.1701 1.83151 23 2.85723 23H8.60578C9.6315 23 10.463 22.1701 10.463 21.1462V13.6527C10.463 12.6289 9.6315 11.799 8.60578 11.799Z",
    fill: "#FF3239",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93989 1H2.52312C1.68192 1 1 1.68065 1 2.52028V7.09095C1 7.93057 1.68192 8.61123 2.52312 8.61123H8.93989C9.78108 8.61123 10.463 7.93057 10.463 7.09095V2.52028C10.463 1.68065 9.78108 1 8.93989 1Z",
    fill: "#FF3239",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTabFeedFill);
export default __webpack_public_path__ + "static/media/icon-tab-feed-fill.88ccd8f93866e82b9c852ccf4b4c9e99.svg";
export { ForwardRef as ReactComponent };